<template>
  <b-modal
    :visible="open"
    centered
    lazy
    @hide="hide"
    @ok="$emit('ok', stars)"
    title-class="text-center"
    :ok-title="$t('MODAL_askEndTraining_question_ok_title')"
    :cancel-title="$t('MODAL_askEndTraining_question_cancel_title')"
    cancel-variant="outline-green"
  >
    <template slot="modal-header">
      <b-container class="text-center w-100 mt-2">
        <h5 class="fa fa-times float-right" @click="hide" />
        <h5 v-t="'MODAL_askEndTraining_question_title'" />
      </b-container>
    </template>
    <template v-if="isLoggedIn">
      <b-row class="pt-2 mb-2">
        <b-col
          class="text-center"
          v-html="$t('MODAL_askEndTraining_question_follow_training')"
        />
      </b-row>
      <b-row class="pb-4 border-bottom">
        <b-col class="text-center" md="8" offset-md="2">
          <b-row>
            <b-col>
              <fa-rating
                style="margin-right: -12px"
                :inline="true"
                :glyph="glyphs.q1"
                :increment="1"
                :spacing="10"
                active-color="#a0c64d"
                inactive-color="#ebf3db"
                border-color="#627c28"
                :border-width="3"
                :item-size="40"
                :show-rating="false"
                v-model="stars.q1"
              ></fa-rating>
            </b-col>
          </b-row>
          <b-row class="small text-muted mt-2">
            <b-col
              offset="1"
              cols="5"
              class="text-left"
              v-t="'MODAL_askEndTraining_question_label_applies_not'"
            />
            <b-col
              cols="5"
              class="text-right"
              v-t="'MODAL_askEndTraining_question_label_applies'"
            />
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-4 mb-2">
        <b-col
          class="text-center"
          v-html="$t('MODAL_askEndTraining_question_more_mobile')"
        />
      </b-row>
      <b-row class="pb-4 border-bottom">
        <b-col class="text-center" md="8" offset-md="2">
          <b-row>
            <b-col>
              <fa-rating
                :inline="true"
                :glyph="glyphs.q2"
                :increment="1"
                :spacing="8"
                active-color="#a0c64d"
                inactive-color="#ebf3db"
                border-color="#627c28"
                :border-width="3"
                :item-size="40"
                :show-rating="false"
                v-model="stars.q2"
              ></fa-rating>
            </b-col>
          </b-row>
          <b-row class="small text-muted mt-2">
            <b-col
              offset="1"
              cols="5"
              class="text-left"
              v-t="'MODAL_askEndTraining_question_label_applies_not'"
            />
            <b-col
              cols="5"
              class="text-right"
              v-t="'MODAL_askEndTraining_question_label_applies'"
            />
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-4 mb-2">
        <b-col
          class="text-center"
          v-html="$t('MODAL_askEndTraining_question_less_pain')"
        />
      </b-row>
      <b-row class="pb-4">
        <b-col class="text-center" md="8" offset-md="2">
          <b-row>
            <b-col>
              <fa-rating
                :inline="true"
                :glyph="glyphs.q3"
                :increment="1"
                :spacing="8"
                active-color="#a0c64d"
                inactive-color="#ebf3db"
                border-color="#627c28"
                :border-width="3"
                :item-size="40"
                :show-rating="false"
                v-model="stars.q3"
              ></fa-rating>
            </b-col>
          </b-row>
          <b-row class="small text-muted mt-2">
            <b-col
              offset="1"
              cols="5"
              class="text-left"
              v-t="'MODAL_askEndTraining_question_label_applies_not'"
            />
            <b-col
              cols="5"
              class="text-right"
              v-t="'MODAL_askEndTraining_question_label_applies'"
            />
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col
          class="text-center text-muted small"
          v-t="'MODAL_askEndTraining_note'"
        />
      </b-row>
    </template>
    <template v-else>
      <b-row>
        <b-col>
          <b-button
            variant="primary"
            class="w-100 mt-3"
            @click.prevent="login"
            >{{ $t('MODAL_rateplaylist_back_to_login') }}</b-button
          >
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { FaRating, ImageRating } from 'vue-rate-it';
import Q1 from 'vue-rate-it/glyphs/lightbulb-o';
import Q2 from 'vue-rate-it/glyphs/star';
import Q3 from 'vue-rate-it/glyphs/leaf';

export default {
  name: 'AskEndTraining',
  components: { FaRating, ImageRating },
  props: ['open', 'events'],
  computed: {
    ...mapGetters(['isLoggedIn']),
    trainingTime() {
      return (
        this.events.length > 1 &&
        Math.floor(
          (this.events[this.events.length - 1].timestamp -
            this.events[0].timestamp) /
            1000
        )
      );
    },
  },
  data() {
    return {
      glyphs: {
        q1: '',
        q2: '',
        q3: '',
      },
      stars: {
        q1: null,
        q2: null,
        q3: null,
      },
    };
  },
  created() {
    this.glyphs = {
      q1: Q1,
      q2: Q2,
      q3: Q3,
    };
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    login() {
      this.hide();
      this.$store.dispatch('openLoginModal');
    },
  },
};
</script>

<style lang="scss" scoped>
:global(.custom-control) {
  padding: 0;
  margin: 2px;
}

#feedback {
  font-size: 1rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/AskEndTraining.vue